var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center flex-start"},[_c('div',{staticClass:"db-ns dn"},[_c('font-awesome-icon',{staticClass:"iconColor pa2",attrs:{"icon":"bars"}})],1),_vm._v(" "),_c('div',{staticClass:"image-container"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.picture),expression:"user.picture"}],staticClass:"mw-100 h-100",attrs:{"src":_vm.picture}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eee72f3","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserInfo.vue
// module id = 763
// module chunks = 4